import { Button, Typography } from '@mui/material';

import { useTranslate } from '@/hooks/useTranslate';

import {
  ApprovedDrawerContainer,
  ApprovedImg,
  StyledApprovedDrawer,
} from './Drawers.styled';

type SuccessSubmissionDrawerProps = Readonly<{
  onClose: () => void;
}>;

export function SuccessSubmissionDrawer({
  onClose,
}: SuccessSubmissionDrawerProps) {
  const { t } = useTranslate();

  return (
    <StyledApprovedDrawer open anchor="bottom" hideBackdrop={false}>
      <ApprovedDrawerContainer>
        <ApprovedImg />
        <Typography variant="headlineH3" textAlign="center" mb={1}>
          {t('moreInfo.successSubmissionDrawer.title')}
        </Typography>

        <Typography variant="bodyB2Regular" textAlign="center" mb={6}>
          {t('moreInfo.successSubmissionDrawer.body')}
        </Typography>

        <Button onClick={onClose} fullWidth>
          {t('moreInfo.successSubmissionDrawer.button.done')}
        </Button>
      </ApprovedDrawerContainer>
    </StyledApprovedDrawer>
  );
}
